<template>
  <div class="e-chart-container" ref="chart"></div>
</template>

<script>
import {debounce} from 'throttle-debounce'
import * as echarts from 'echarts'
import { addResizeListener, removeResizeListener } from 'element-ui/lib/utils/resize-event'

export default {
  name: 'EChartContainer',
  data () {
    return {
      chartEl: null,
      chart: null
    }
  },
  methods: {
    initEChart () {
      this.chartEl = this.$refs['chart']
      if (this.chartEl) {
        addResizeListener(this.chartEl, this.resizeHolder)
        this.chart = echarts.init(this.chartEl)
      }
    },
    destroyEChart () {
      if (this.chartEl) {
        removeResizeListener(this.chartEl, this.resizeHolder)
        this.chart && this.chart.dispose()
      }
    },
    setOption (option) {
      this.chart && this.chart.setOption(option)
    },
    clear () {
      this.chart && this.chart.clear()
    }
  },
  mounted () {
    this.resizeHolder = debounce(200, () => {
      this.chart && this.chart.resize()
    })
    this.initEChart()
  },
  destroyed () {
    this.destroyEChart()
  }
}
</script>
